import HeaderDesktopView from "./HeaderDesktopView";
import HeaderMobileView from "./HeaderMobileView";

import { USER_VIEW } from '../../common/constant/common-constants';

export function Header(props) {

    return (
        <>
            {props?.userView === USER_VIEW.DESKTOP && (
                <HeaderDesktopView
                    hospitalName={props.hospitalName}
                    selectedWard={props.selectedWard}
                    handleWardChange={props.handleWardChange}
                    wardOption={props.wardOption}
                    isDisabled={props.isDisabled}
                />
            )}

            {props?.userView === USER_VIEW.MOBILE && (
                <HeaderMobileView
                    hospitalName={props.hospitalName}
                    selectedWard={props.selectedWard}
                    handleWardChange={props.handleWardChange}
                    wardOption={props.wardOption}
                    isDisabled={props.isDisabled}
                    wardData={props.wardData}
                    handleSigoutClick = {props.handleSigoutClick}
                />
            )}
        </>
    );

}

